import { Flow } from 'signup-constants/Flow';
import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { getApplicationLocale } from '../i18n/LocaleUtils';
import { getFlowKey } from '../routing/getFlowKey';
import { Data } from '../signup-data/DATA';
import { getIsNewUser } from '../store/app/selectors';
import { isSoftwareSignup } from '../store/flow/selectors';
import { getIsMobile } from '../utils/deviceUtils';
import { getHasHubsSignupUrlParamForACQ111 } from './acq111/acq111Utils';
import { isExposedToDist008 } from './dist008Utils';
import { enrollOnFlow } from './experimentDefaults';
import { ExperimentKeys, TEST_KEY } from './ExperimentKeys';
import { getIsNewUserExperiment } from './ExperimentUtils';
export const EXPERIMENT_ID = 'experimentId';
const SEEN_EXPERIMENTS = new Set();
const Experiments = new Map([[ExperimentKeys.ONBF016, {
  shouldEnroll: state => {
    const {
      signupData
    } = state;
    const industry = signupData[Data.Industry].value;
    const isCrmFlow = [Flow.Crm].includes(getFlowKey());
    const isNotMobile = !getIsMobile();
    const isNotMarketingAndAdvertisingIndustry = industry !== 'marketing-and-advertising';
    const isNewUser = getIsNewUser(state);
    return isCrmFlow && isNotMobile && isNotMarketingAndAdvertisingIndustry && isNewUser;
  }
}], [ExperimentKeys.DIST008, {
  shouldEnroll: () => {
    return isExposedToDist008();
  }
}], [ExperimentKeys.BIAB001, {
  shouldEnroll: state => {
    return getFlowKey() === Flow.Crm && getApplicationLocale() === Locale.en && state.signupData[Data.Industry].value === 'marketing-and-advertising';
  }
}], [ExperimentKeys.ACQ117, {
  shouldEnroll: state => {
    const isCorrectFlow = [Flow.Crm, Flow.Marketing, Flow.Service, Flow.Sales].includes(getFlowKey());
    const isMobile = getIsMobile();
    const isNewUser = getIsNewUserExperiment(state);
    return isCorrectFlow && isNewUser && !isMobile;
  }
}], [ExperimentKeys.ACQ122, {
  shouldEnroll: state => {
    const isCorrectFlow = isSoftwareSignup();
    const isNewUser = getIsNewUserExperiment(state);
    const hasHubsSignupUrlParamForACQ111 = getHasHubsSignupUrlParamForACQ111();
    return isCorrectFlow && isNewUser && !hasHubsSignupUrlParamForACQ111;
  }
}], [ExperimentKeys.ACQ123, {
  shouldEnroll: state => {
    const isCorrectFlow = [Flow.Crm, Flow.Sales, Flow.Service, Flow.Marketing].includes(getFlowKey());
    const isNewUser = getIsNewUserExperiment(state);
    const hasHubsSignupUrlParamForACQ111 = getHasHubsSignupUrlParamForACQ111();
    return isCorrectFlow && isNewUser && !hasHubsSignupUrlParamForACQ111;
  }
}]]);
export const getExperiment = id => {
  // we want to prefer this solution over mocking getExperiment so that the
  // seen experiments tracking below continues to work and doesn't get
  // accidentally mocked
  if (id === TEST_KEY) {
    return {
      shouldEnroll: () => enrollOnFlow([Flow.Crm])
    };
  }

  SEEN_EXPERIMENTS.add(id);
  return Experiments.get(id);
};
export function getSeenExperimentsForTesting() {
  return Array.from(SEEN_EXPERIMENTS);
}